import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { uniqueArray, hasKeys, getLanColor } from 'utils';
import Icon from 'screens/shared/icon';
import Dropdown from './select-field';

export default ({
  label = 'LANs',
  value,
  isPrivateOnly = false,
  isDcAlreadyLoading = false,
  datacenterId = '',
  onChange,
  error,
  style = {},
}) => {
  const [lan, setLan] = useState('');

  const { [ACTIONS_TYPES.DATA_CENTER.GET]: dataCenter = {} } = useSelector((e) => e);
  const { entities: { lans } = { lans: {} } } = dataCenter;
  let { items: lanItems = [] } = lans;
  lanItems = isPrivateOnly ? lanItems.filter(({ properties: { public: _public = true } = {} }) => !_public) : lanItems;

  const mapLanOptions = ({
    id, isOnlyShow = false, isLabel = true, properties: { name = '', public: isPublic = true } = {},
  }) => {
    const lanTemplate = (
      <span className="lan-selector-option" style={{ position: 'relative' }}>
        <Icon
          name="ethernet"
          style={{
            backgroundColor: getLanColor(id), paddingBottom: 10, paddingTop: 3, borderRadius: 'var(--border-radius)',
          }}
        />
        {(isLabel || isPrivateOnly) && (
          <span style={{
            position: 'absolute', bottom: 1, left: 2, lineHeight: '9px', fontSize: 9, color: 'white',
          }}
          >
            {isPrivateOnly ? 'Private' : isPublic ? 'Public' : 'Private'}
          </span>
        )}
        {`LAN ${id} ${name ? ` - ${name}` : ''}`}
      </span>
    );

    return (isOnlyShow ? lanTemplate : [
      id,
      lanTemplate,
    ]);
  };

  const lansOptions = lanItems.map(mapLanOptions);

  useEffect(() => {
    if (!hasKeys(dataCenter) && !isDcAlreadyLoading) {
      actions.dataCenter.get({ id: datacenterId });
    }
  }, [dataCenter, isDcAlreadyLoading, datacenterId]);

  const changeDropdownHandler = (e) => (
    setLan(e.target.value)
  );

  const addHandler = () => {
    onChange(uniqueArray([...value, lan]));
    return setLan('');
  };

  const deleteHandler = (i) => {
    value.splice(i, 1);
    onChange(value);
  };

  return (
    <div>
      <div className="ips-selector" style={error ? { border: '1px solid #f44336' } : {}}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
        }}
        >
          <Dropdown
            style={{
              width: 'calc(100% - 100px)', marginTop: 4, marginBottom: 8, ...style,
            }}
            label={label}
            value={lan}
            onChange={changeDropdownHandler}
            values={lansOptions}
            error={error}
          />
          <Button variant="contained" size="small" color="primary" onClick={addHandler} style={{ marginLeft: 10 }}>Add LAN</Button>
        </div>

        <div style={{ margin: '10px 0', display: 'flex', flexWrap: 'wrap' }}>
          {value.map((e, i) => (
            <span
              style={{
                background: 'var(--color-ground)',
                marginRight: 10,
                marginBottom: 10,
                padding: 10,
                display: 'flex',
                alignItems: 'center',
                borderRadius: 'var(--border-radius)',
              }}
              key={i}
            >
              {mapLanOptions({ isOnlyShow: true, id: e, isLabel: false })}
              <span className="ips-selector-delete" title="Remove" onClick={() => deleteHandler(i)}>
                <Icon name="times" style={{ color: 'white' }} />
              </span>
            </span>
          ))}
        </div>
      </div>
      { error && (
        <span style={{
          color: '#f44336', fontSize: 12, top: -8, left: 14, position: 'relative',
        }}
        >
          {error}
        </span>
      )}
    </div>
  );
};
